var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.progressBarValues)?_c('div',[_c('p',{staticClass:"text-muted"},[_c('strong',[_vm._v("\n      Database Capacity - "+_vm._s(_vm._f("number")(_vm.campaignRecordsRemaining.limit))+" Limit\n    ")])]),_c('stacked-progress-bar',{attrs:{"values":_vm.progressBarValues}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }